import HistoricThreadModal from "@/pages/chat/components/HistoricThreadModal";

export default function SearchTranscriptModal(props) {
  return <HistoricThreadModal {...props} showTranscriptExports />;
}
